<svg width="60" height="16" viewBox="0 0 60 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="arrow-gray">
        <path id="Path 8" d="M1 14.1445C1 14.1445 15.3425 1.06325 29.5 1.00116C43.6575 0.939066 58 13.8945 58 13.8945"
              stroke="#E2E2E2" strokeWidth="2" stroke-linecap="round" stroke-dasharray="2 4"/>
        <path id="Path 3" d="M54 14.8945H59V9.89453" stroke="#E2E2E2" strokeWidth="1.5"/>
    </g>
</svg>
